import React from "react";
import VeltCommentDialogThreadCardAvatar from "./VeltCommentDialogThreadCardAvatar/VeltCommentDialogThreadCardAvatar";
import VeltCommentDialogThreadCardDeviceType from "./VeltCommentDialogThreadCardDeviceType/VeltCommentDialogThreadCardDeviceType";
import VeltCommentDialogThreadCardFiles from "./VeltCommentDialogThreadCardFiles/VeltCommentDialogThreadCardFiles";
import VeltCommentDialogThreadCardMessage from "./VeltCommentDialogThreadCardMessage/VeltCommentDialogThreadCardMessage";
import VeltCommentDialogThreadCardName from "./VeltCommentDialogThreadCardName/VeltCommentDialogThreadCardName";
import VeltCommentDialogThreadCardOptions from "./VeltCommentDialogThreadCardOptions/VeltCommentDialogThreadCardOptions";
import VeltCommentDialogThreadCardReactions from "./VeltCommentDialogThreadCardReactions/VeltCommentDialogThreadCardReactions";
import VeltCommentDialogThreadCardReactionTool from "./VeltCommentDialogThreadCardReactionTool/VeltCommentDialogThreadCardReactionTool";
import VeltCommentDialogThreadCardRecordings from "./VeltCommentDialogThreadCardRecordings/VeltCommentDialogThreadCardRecordings";
import VeltCommentDialogThreadCardTime from "./VeltCommentDialogThreadCardTime/VeltCommentDialogThreadCardTime";
;
// Main Thread Card component
var VeltCommentDialogThreadCard = function (props) {
    var children = props.children;
    return (React.createElement("velt-comment-dialog-thread-card-wireframe", null, children));
};
// Attach the Sub component as a static property of the main Thread Card component
VeltCommentDialogThreadCard.Avatar = VeltCommentDialogThreadCardAvatar;
VeltCommentDialogThreadCard.DeviceType = VeltCommentDialogThreadCardDeviceType;
VeltCommentDialogThreadCard.Files = VeltCommentDialogThreadCardFiles;
VeltCommentDialogThreadCard.Message = VeltCommentDialogThreadCardMessage;
VeltCommentDialogThreadCard.Name = VeltCommentDialogThreadCardName;
VeltCommentDialogThreadCard.Options = VeltCommentDialogThreadCardOptions;
VeltCommentDialogThreadCard.Reactions = VeltCommentDialogThreadCardReactions;
VeltCommentDialogThreadCard.ReactionTool = VeltCommentDialogThreadCardReactionTool;
VeltCommentDialogThreadCard.Recordings = VeltCommentDialogThreadCardRecordings;
VeltCommentDialogThreadCard.Time = VeltCommentDialogThreadCardTime;
export default VeltCommentDialogThreadCard;
